import http from './http'

const vehicleRoute = '/vehicle/'

export default {
    async vehicleLookup (registration) {
        return http.get(vehicleRoute + 'lookup/' + registration)
    }
}
